/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Export_CsvInputs */



/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Knp_Terms_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_export_csv = /** @type {((inputs?: Knp_Terms_Export_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Export_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出 CSV 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSVエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar CSV")
	return /** @type {LocalizedString} */ ("Export CSV")
});